import React, { HTMLAttributes, PropsWithChildren, useState } from 'react';
import { createUseStyles } from 'react-jss';
import Popper from '../../../../../components/Popper';
import ClickAwayListener from '../../../ClickAwayListener';
import clsx from 'clsx';

interface Props<T> extends HTMLAttributes<HTMLElement> {
  buttonComponent: any;
  list: Array<T>;
  onMarkAllSeen?: () => void;
  renderDropDownItem: (item: T, key: number) => any;
  title?: string;
  loading?: boolean;
  fullWidthMenu?: boolean;
  emptyText?: string;
  menuClassName?: any;
  headerClassName?: any;
}

const useStyles = createUseStyles({
  root: {
    zIndex: 15,
  },
  menu: {
    width: 350,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    boxShadow: '0 0 35px 0 rgba(154,161,171,.15)',
    padding: '.25rem 0',
    border: '1px solid #e4eaf2',
    borderRadius: '.25rem',
    marginTop: 10,
  },
  list: {
    maxHeight: 230,
    overflow: 'auto',
    marginBottom: 15,
  },
  menuHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '15px 20px',
    width: '100%',
    '& .title': {
      fontWeight: 700,
      fontSize: '.9rem',
    },
  },
  clearAll: {
    fontSize: '.75rem',
    fontWeight: 400,
    cursor: 'pointer',
  },
  alignCenter: {
    padding: '7px 20px',
    textAlign: 'center',
  },
});

function DropDown<T>({
  className,
  headerClassName,
  menuClassName,
  onMarkAllSeen,
  buttonComponent: ButtonComponent,
  renderDropDownItem,
  fullWidthMenu,
  emptyText,
  list,
  title,
  loading,
}: PropsWithChildren<Props<T>>) {
  const classes = useStyles();

  const [menuOpen, setMenuOpen] = useState(false);
  const [iconRef, setIconRef] = useState<HTMLElement | null>(null);

  return (
    <div className={clsx(classes.root, className)}>
      {iconRef && menuOpen && (
        <Popper fullWidth={fullWidthMenu} anchorEl={iconRef}>
          <ClickAwayListener onClickAway={() => setMenuOpen(false)}>
            <div className={clsx(classes.menu, menuClassName)}>
              <div className={clsx(classes.menuHeader, headerClassName)}>
                {title && <div className='title'>{title}</div>}
                {onMarkAllSeen && (
                  <div className={classes.clearAll} onClick={onMarkAllSeen}>
                    Tout marquer comme lu
                  </div>
                )}
              </div>

              {loading && <div className={classes.alignCenter}>Chargement ...</div>}

              <div className={classes.list} onClick={() => setMenuOpen(false)}>
                {list.map(renderDropDownItem)}
              </div>

              {list.length <= 0 && <div className={classes.alignCenter}>{emptyText || ''}</div>}
            </div>
          </ClickAwayListener>
        </Popper>
      )}

      <div ref={setIconRef}>
        <ButtonComponent onClick={() => setMenuOpen(true)} />
      </div>
    </div>
  );
}

export default DropDown;
